import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["startedAt", "finishedAt"];

  initialize() {
    this.reloadPage();
  }

  reloadPage() {
    if (!this.startedAtTarget.value || !this.finishedAtTarget.value) {
      setTimeout( () => {
        location.reload();
        this.reloadPage();
      }, 3000)
    }
  }
}
